// @ts-nocheck

import { BasketStatuses } from '../../types/basket';
import palette from '../palette';

export const PresetsButton = {
  color: palette.white,
  backgroundColor: palette.bluegrey700,
  hoverBackgroundColor: palette.neutralgrey800,
  activeBackgroundColor: palette.bluegrey400,
};

export const BasketTabs = {
  default: {
    backgroundColor: palette.bluegrey800,
    color: palette.neutralgrey200,
    circleBackgroundColor: palette.transparent,
  },
  selected: {
    backgroundColor: palette.white,
    color: palette.black,
    circleBackgroundColor: palette.red200,
  },
  disabled: {
    backgroundColor: palette.bluegrey850,
    color: palette.bluegrey300,
    circleBackgroundColor: palette.transparent,
  },
};

export const StakeInput = {
  backgroundColor: palette.bluegrey850,
  color: palette.white,
  errorColor: palette.red100,
  placeholderColor: palette.neutralgrey350,
  borderColor: palette.bluegrey350,
  focusedBorderColor: palette.yellowwinamax450,
};

export const BasketHeader = {
  backgroundColor: palette.bluegrey850,
  selectionColor: palette.white,
  defaultColor: palette.neutralgrey200,
};

export const BasketCombinationsSliderCell = {
  backgroundColor: palette.black,
  labelColor: palette.white,
  counterColor: palette.neutralgrey450,
  borderColor: palette.neutralgrey550,
};

export const BasketCombinationsSummary = {
  titleColor: palette.neutralgrey200,
  counterLabelColor: palette.neutralgrey200,
  counterNumberColor: palette.white,
  updateButtonBackgroundColor: palette.white,
  updateButtonColor: palette.black,
};

export const BasketCombinationsSelectorLine = {
  labelColor: palette.white,
  counterColor: palette.neutralgrey450,
  separatorBackgroundColor: palette.neutralgrey700,
};

export const BasketCombinationsSelector = {
  resetButtonBackgroundColor: palette.bluegrey700,
  resetButtonColor: palette.white,
  resetButtonBorderColor: palette.transparent,
  submitButtonBackgroundColor: palette.red200,
  submitButtonColor: palette.white,
  submitButtonBorderColor: palette.transparent,
};

export const BasketCard = {
  potentialWinningsColor: palette.yellowwinamax450,
  closeButtonColor: palette.neutralgrey350,
  subLabelColor: palette.neutralgrey200,
};

export const BasketFooter = {
  backgroundColor: palette.bluegrey850,
  borderTopColor: palette.bluegrey750,
  previousOddColor: palette.neutralgrey550,
};

export const BasketSystems = {
  mobileBackgroundColor: palette.bluegrey850,
};

export const Basket = {
  addedCashoutItemsBackgroundColor: palette.neutralgrey800,
  separatorCashoutItemsBackgroundColor: palette.bluegrey700,
  readOnlyStakeBackgroundColor: palette.bluegrey925,
  readOnlyStakeLeftColor: palette.white,
  readOnlyStakeRightColor: palette.white,
  keyboardMobileModalBackgroundColor: palette.bluegrey850,
  contentBackgroundColor: palette.black,
};

export const BasketAlert = {
  [BasketStatuses.VALIDATED]: { color: palette.white, backgroundColor: palette.greenwinamax450 },
  [BasketStatuses.ERROR]: { color: palette.redinfo200, backgroundColor: palette.redinfo900 },
  [BasketStatuses.REJECTED]: { color: palette.redinfo200, backgroundColor: palette.redinfo900 },
  [BasketStatuses.WAITING]: { color: palette.white, backgroundColor: palette.yellowwinamax600 },
  [BasketStatuses.PENDING]: { color: palette.white, backgroundColor: palette.yellowwinamax600 },
  default: { color: palette.neutralgrey700, backgroundColor: palette.neutralgrey350 },
};

export const BasketSummary = {
  potentialBorderColor: palette.neutralgrey700,
  boosterSentenceColor: palette.neutralgrey450,
  totalOddColor: palette.neutralgrey200,
};

export const BasketCtas = {
  primary: {
    color: palette.white,
    backgroundColor: palette.red200,
  },
  secondary: {
    color: palette.black,
    backgroundColor: palette.white,
  },
  tertiary: {
    color: palette.white,
    backgroundColor: palette.bluegrey700,
  },
  cashout: {
    color: palette.black,
    backgroundColor: palette.yellowwinamax450,
  },
};

export const BasketFreebetHelper = {
  modalBackgroundColor: palette.bluegrey850,
  circleStrokeColor: palette.greenwinamax450,
  color: palette.neutralgrey200,
};

export const BasketMobileModal = {
  slideMarkBackgroundColor: palette.neutralgrey550,
  modalBackgroundColor: palette.black,
};

export const BasketDETaxModal = {
  descriptionColor: palette.neutralgrey200,
  mainColor: palette.white,
  innerBackground: palette.bluegrey900,
};

export const BasketDETaxRow = {
  savedAmountColor: palette.red100,
};

export const FloatingBasketButton = {
  backgroundColor: palette.red200,
};
